<template>
  <v-btn icon @click="chevronUpDown = !chevronUpDown">
    <v-icon>
      {{ chevronUpDown ? mdiChevronUp : mdiChevronDown }}
    </v-icon>
  </v-btn>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

interface IProps {
  value?: boolean;
}

interface IEmits {
  (event: 'input', value: boolean): void;
}

const props = defineProps<IProps>();
const emit = defineEmits<IEmits>();

const chevronUpDown = ref(props.value);

watch(chevronUpDown, (newValue, oldValue) => {
  if (newValue !== oldValue) emit('input', chevronUpDown.value || false);
});

watch(
  () => props.value,
  async (newValue, oldValue) => {
    if (newValue != oldValue) {
      chevronUpDown.value = newValue;
    }
  },
  { deep: true }
);
</script>
